/**
 * Generates a display ID from capture and optional specimen UUIDs.
 * Format: `[datePrefix_]Mesh_<last6 of captureUuid>[_D_<last6 of specimenUuid>]`
 */
export const generateDisplayId = ({
  captureUuid,
  specimenUuid,
  timestamp,
}: {
  captureUuid?: string;
  specimenUuid?: string;
  timestamp?: string | Date;
}): string => {
  const datePrefix = timestamp ? `${formatIdDate(timestamp)}_` : "";
  const captureUuidLast6 = captureUuid?.slice(-6) ?? "";
  if (!specimenUuid) {
    return `${datePrefix}Mesh_${captureUuidLast6}`;
  }
  const specimenUuidLast6 = specimenUuid.slice(-6);
  return `${datePrefix}Mesh_${captureUuidLast6}_D_${specimenUuidLast6}`;
};

export const formatIdDate = (dateString: string | Date | undefined): string => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${year}${month}${day}_${hours}${minutes}`;
};
